import {toArray} from 'lodash';
import axios from 'axios';

const formElementSelector = '.review-form-element';
const targetElementSelector = '.is-review-form-target-element';
const targetElementHeadlineSelector = '.is-review-headline';
const targetElementTextSelector = '.is-review-text';
const starsSelector = '.radio-star';

export default class ReviewForm {

  constructor(el) {
    this.el = el;
    this.formElementArr = toArray(this.el.querySelectorAll(formElementSelector));
    this.targetElement = document.querySelector(targetElementSelector);
    this.targetElementHeadline = this.targetElement.querySelector(targetElementHeadlineSelector);
    this.targetElementHeadlineDefaultValue = this.targetElementHeadline.innerHTML;
    this.targetElementText = this.targetElement.querySelector(targetElementTextSelector);
    this.targetElementTextDefaultValue = this.targetElementText.innerHTML;
    this.starArr = toArray(this.el.querySelectorAll(starsSelector));
    this.targetStarArr = toArray(this.targetElement.getElementsByTagName('i'));
    this.feedbackElem = el.querySelector('.alert');

    Object.assign(this.targetElement.style, {
      maxHeight: '0px',
      padding: '0',
      overflow: 'hidden',
      transitionProperty: 'max-height, padding',
      transitionDuration: '0.3s'
    });

    this.el.addEventListener('submit', this.submitForm.bind(this), false);

    this.starArr.forEach(elem => {
      elem.addEventListener('change', this.setRatingStars.bind(this), false);
    });
  }

  submitForm(e) {

    e.preventDefault();
    const form = this.el;
    this.feedbackElem.style.display = 'none';

    axios({
      method: 'post',
      url: form.action,
      data: new FormData(form),
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(res => {
        if (res.data.success) {

          if (res.data.message) {
            this.feedbackElem.className = 'alert alert-success';
            this.feedbackElem.style.display = 'block';
            this.feedbackElem.querySelector('.inner-wrapper').textContent = res.data.message;
          }

          const firstDivElem = document.querySelector('#reviews-container > div:first-child');

          if (!res.data.content) {
            return;
          }

          firstDivElem[firstDivElem.outerHTML ? 'outerHTML' : 'innerHTML'] = res.data.content;

          const container = form.closest('.container');

          if (!container) {
            return;
          }

          Object.assign(container.style, {
            maxHeight: '700px',
            overflow: 'hidden',
            transition: 'max-height 0.3s'
          });

          window.setTimeout(() => {
            container.style.maxHeight = '0px';
          }, 3000 );
        } else {
          if (!res.data.message) {
            return;
          }

          let message = res.data.message;

          if (Array.isArray(res.data.message)) {
            message = res.data.message.join('\n');
          }

          this.feedbackElem.className = 'alert alert-error';
          this.feedbackElem.style.display = 'block';
          this.feedbackElem.querySelector('.inner-wrapper').textContent = message;
        }
      })
      .catch(error => {
        throw `ReviewForm.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
      });
  }

  setRatingStars(e) {
    const targetValue = e.target.defaultValue;
    const activeStarArr = this.targetStarArr.slice(0, targetValue);

    this.targetStarArr.forEach(elem => {
      elem.classList.remove('is-active');
    });

    activeStarArr.forEach(elem => {
      elem.classList.add('is-active');
    });
  }

}
